<template>
<with-loader :id="id" :loading="isLoading" class="h-full w-full" v-bar>
  <ul class="max-h-full" :class="unorderedListClasses">
    <li v-for="(item, i) of list"
        :key="i"
        class="text-gray-dark"
        :class="listClasses"
    >
      {{ item }}
    </li>
  </ul>
</with-loader>
</template>

<script>
import WithLoader from '@/components/common/WithLoader'

export default {
  name: 'UnorderedList',
  components: { WithLoader },
  props: {
    id: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    list: {
      type: [Array, Set],
      default: () => []
    },
    listClasses: {
      type: Array
    },
    unorderedListClasses: {
      type: Array,
      default: () => ['list-disc', 'pl-5', 'pr-2', 'pb-5']
    }
  }
}
</script>
